import React, { useState } from 'react';
import { Button } from '@components/ui/button';
import { Card } from '@components/ui/card';

const USAGE_STYLES = [
  {
    id: 'quick-support',
    title: 'Quick Support & Clarifications',
    description: "I'll mainly use it when I have specific questions or need quick explanations.",
  },
  {
    id: 'focused-sessions',
    title: 'Focused Learning Sessions',
    description: 'I plan to use it for dedicated sessions when I want to dive deep into a topic.',
    selected: true,
  },
  {
    id: 'regular-checkins',
    title: 'Regular Check-ins & Review',
    description: "I'd like to use it to periodically review concepts and reinforce my understanding.",
  },
  {
    id: 'flexible-allrounder',
    title: 'Flexible All-Rounder',
    description: "I'll use it as needed - for quick questions, deep dives, and ongoing review.",
  },
];

const UsageStyleStep = ({ onNext, onBack, formData, canGoBack }) => {
  const [selectedStyle, setSelectedStyle] = useState(formData.usageStyle || 'focused-sessions');

  const handleContinue = () => {
    onNext({ usageStyle: selectedStyle });
  };

  return (
    <div className="space-y-8 animate-fade-in">
      <div className="text-center space-y-4">
        <h1 className="text-3xl font-bold text-foreground">How do you plan to use Opennote?</h1>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Understanding your style helps us make Opennote a better learning companion for you.
        </p>
      </div>

      <div className="space-y-4">
        <p className="text-sm font-medium text-foreground">Choose your usage style</p>

        <div className="space-y-4">
          {USAGE_STYLES.map((style) => (
            <Card
              key={style.id}
              className={`p-6 cursor-pointer transition-all hover:bg-secondary/80 ${
                selectedStyle === style.id ? 'bg-primary/10 border-primary' : 'bg-secondary border-border'
              }`}
              onClick={() => setSelectedStyle(style.id)}>
              <div className="flex items-start space-x-4">
                <div
                  className={`w-5 h-5 rounded-full border-2 mt-0.5 flex-shrink-0 ${
                    selectedStyle === style.id ? 'bg-primary border-primary' : 'border-border'
                  }`}>
                  {selectedStyle === style.id && <div className="w-full h-full rounded-full bg-primary" />}
                </div>
                <div className="space-y-2">
                  <h3 className="font-semibold text-foreground">{style.title}</h3>
                  <p className="text-sm text-muted-foreground">{style.description}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>

      <div className="flex justify-between pt-8">
        {canGoBack && (
          <Button variant="outline" onClick={onBack} className="px-8">
            Back
          </Button>
        )}
        <Button onClick={handleContinue} disabled={!selectedStyle} className="px-8 ml-auto">
          Continue
        </Button>
      </div>
    </div>
  );
};

export default UsageStyleStep;
